import AdjustOutlined from "@mui/icons-material/AdjustOutlined";
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRounded from "@mui/icons-material/ErrorOutlineRounded";
import { Skeleton } from "@mui/material";
import { ReportStepState } from "util/reportStepMetadata";

export const StepStatusIcon = ({ status }: { status: ReportStepState }) => {
  switch (status) {
    case ReportStepState.NotStarted:
      return <AdjustOutlined color="action" />;
    case ReportStepState.Done:
      return <CheckCircleOutlineRounded color="success" />;
    case ReportStepState.Invalid:
      return <ErrorOutlineRounded color="error" />;
    case undefined:
      return <Skeleton variant="circular" width={20} height={20} />;
    default:
      ((_: never) => {
        throw new Error(`Unexpected value: ${_}`);
      })(status);
  }
};
